import {observe} from 'mobx';

import React from 'react';

const Begin = class Begin extends React.Component {
  componentDidUpdate() {
    const { button, nextStep, parent, statusClass } = this.props;
    const { SessionStore } = this.props.store;
    const translation = this.props.translation.begin;

    if(statusClass === 'slide-active' && parent.state.next !== nextStep) {
      parent.setState({
        next: nextStep
      });

      // Don't let the user continue if there are background loading calls
      button.disabled = SessionStore.backgroundLoading;

      if(SessionStore.backgroundLoading) {
        button.textContent = translation.loading;

        const disposer = observe(SessionStore, 'backgroundLoading', change => {
          if(change.newValue === false) {
            button.disabled = false;
            button.textContent = translation.button;
            disposer();
          }
        });
      } else {
        button.textContent = translation.button;
      }
    }
  }

  render() {
    const { statusClass } = this.props;
    const translation = this.props.translation.begin;

    return (
      <main className={`panel panel--medium ${statusClass}`} aria-labelledby="step1">
        <h2 className="panel__title panel__title--alt" id="step1">
          {translation.heading}
        </h2>

        <p>{translation.body}</p>

        <p className="note note--prominent">{translation.note}</p>
      </main>
    )
  }
}

export default Begin;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/Begin.js